import { render, staticRenderFns } from "./CreateLand.vue?vue&type=template&id=7eb5e567&"
import script from "./CreateLand.vue?vue&type=script&lang=js&"
export * from "./CreateLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports